export default __webpack_public_path__ + "img/0f6a6cb420216e610524c7fb290ef802.png";